import { Button, LinkDiagonalIcon, useToast } from "@flat-ui";
import {
  LogEventParams,
  useTrackEvent,
} from "@utils/track-event/use-track-event";
import { copyToClipboard } from "@utils/ui-utils";

interface Props {
  /** Params to pass to send appropriate events */
  logEventParams: LogEventParams;

  /** The URL that should be copied to the clipboard when clicking the button */
  targetHref: string;
}

/** Renders copy link button with functionality for specified target URL */
export function CopyLinkButton({
  logEventParams,
  targetHref,
}: Props): JSX.Element {
  const { openToast } = useToast();
  const { trackEvent } = useTrackEvent();

  /** Copies the URL to the clipboard */
  function copyUrl(): void {
    copyToClipboard(targetHref);

    trackEvent(logEventParams);

    openToast({
      title: "Link copied",
    });
  }

  return (
    <Button variant="ghost" icon={<LinkDiagonalIcon />} onClick={copyUrl}>
      Copy link
    </Button>
  );
}
